import { c as _c } from "react/compiler-runtime";
import type { GetHistoryEntry } from '@repo/schema/history';
import { ChangeLine } from './history-change-line.tsx';
import { HistoryRow } from './history-row.tsx';
import { useHistoryEntity } from '../history-utils/entity.ts';
import { getFieldTitle } from '../history-utils/labels.ts';
export const ChangeRow = t0 => {
  const $ = _c(9);
  const {
    entry
  } = t0;
  const entity = useHistoryEntity();
  let t1;
  if ($[0] !== entity || $[1] !== entry) {
    t1 = getFieldTitle(entry, entity);
    $[0] = entity;
    $[1] = entry;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== entry) {
    t2 = <ChangeLine entry={entry} data-sentry-element="ChangeLine" data-sentry-source-file="history-change-row.tsx" />;
    $[3] = entry;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== entry || $[6] !== t1 || $[7] !== t2) {
    t3 = <HistoryRow entry={entry} title={t1} data-sentry-element="HistoryRow" data-sentry-component="ChangeRow" data-sentry-source-file="history-change-row.tsx">{t2}</HistoryRow>;
    $[5] = entry;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};